export type BlogCoverFallback = {
  cover: string;
  coverAlt: string;
};

/**
 * أغلفة محلية للمقالات القديمة التي حُفظت بلا صورة.
 * لا تُستخدم إلا عند غياب cover في RTDB، لذلك تبقى الصور التي رفعها
 * الأدمن أو حُفظت سابقاً كما هي.
 */
export const BLOG_COVER_FALLBACKS: Record<string, BlogCoverFallback> = {
  "ادوات-باك-زون-كيف-تستعملها": {
    cover: "/blog/covers/ادوات-باك-زون-كيف-تستعملها.webp",
    coverAlt: "دفتر تخطيط وملاحظات على مكتب للمراجعة",
  },
  "النوم-والتغذية-اثناء-المراجعة": {
    cover: "/blog/covers/النوم-والتغذية-اثناء-المراجعة.webp",
    coverAlt: "تلميذة تراجع قرب الحاسوب مع مشروب في جلسة منزلية",
  },
  "طرق-المراجعة-الفعالة": {
    cover: "/blog/covers/طرق-المراجعة-الفعالة.webp",
    coverAlt: "كتب مفتوحة ومواد دراسية لجلسة مراجعة",
  },
  "التعامل-مع-قلق-الامتحان": {
    cover: "/blog/covers/التعامل-مع-قلق-الامتحان.webp",
    coverAlt: "تلميذ يشعر بضغط الامتحان داخل قاعة الدراسة",
  },
  "حساب-معدل-البكالوريا-بنفسك": {
    cover: "/blog/covers/حساب-معدل-البكالوريا-بنفسك.webp",
    coverAlt: "آلة حاسبة ودفتر مفتوح لحساب النتائج الدراسية",
  },
  "مراجعة-اللغات-الاجنبية": {
    cover: "/blog/covers/مراجعة-اللغات-الاجنبية.webp",
    coverAlt: "تلميذة تتعلم لغة وتدوّن ملاحظات من كتاب",
  },
  "مراجعة-التاريخ-والجغرافيا": {
    cover: "/blog/covers/مراجعة-التاريخ-والجغرافيا.webp",
    coverAlt: "خريطة مفتوحة في كتاب للمراجعة في التاريخ والجغرافيا",
  },
  "مراجعة-الرياضيات": {
    cover: "/blog/covers/مراجعة-الرياضيات.webp",
    coverAlt: "آلة حاسبة ودفتر تمارين رياضيات على مكتب",
  },
  "مراجعة-العلوم-الاسلامية": {
    cover: "/blog/covers/مراجعة-العلوم-الاسلامية.webp",
    coverAlt: "يد تدوّن ملاحظات في دفتر أثناء المراجعة",
  },
  "مراجعة-العلوم-الطبيعية": {
    cover: "/blog/covers/مراجعة-العلوم-الطبيعية.webp",
    coverAlt: "تلاميذ داخل مختبر علوم يجرون تجربة تعليمية",
  },
  "مراجعة-الفيزياء": {
    cover: "/blog/covers/مراجعة-الفيزياء.webp",
    coverAlt: "شرح فيزياء أمام سبورة تحتوي على معادلات",
  },
  "استعمال-الحوليات-والمواضيع-السابقة": {
    cover: "/blog/covers/استعمال-الحوليات-والمواضيع-السابقة.webp",
    coverAlt: "تلميذ يكتب إجابة في اختبار داخل قاعة",
  },
  "المقالة-الفلسفية": {
    cover: "/blog/covers/المقالة-الفلسفية.webp",
    coverAlt: "كتابة ملاحظات في دفتر للمقالة والدراسة",
  },
  "يوم-امتحان-البكالوريا": {
    cover: "/blog/covers/يوم-امتحان-البكالوريا.webp",
    coverAlt: "تلاميذ يكتبون في قاعة امتحان",
  },
};

export function getBlogCoverFallback(slug: string): BlogCoverFallback | undefined {
  return BLOG_COVER_FALLBACKS[slug];
}
